'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useListContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useListContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useListContextValues_unstable(state) {
    const { selection, navigationMode, listItemRole, validateListItem } = state;
    const listContext = {
        selection,
        navigationMode,
        validateListItem
    };
    const synchronousContext = _react.useMemo(()=>({
            listItemRole,
            navigationMode
        }), [
        listItemRole,
        navigationMode
    ]);
    return {
        listContext,
        synchronousContext
    };
}
